module.exports = __webpack_public_path__ + "static/media/pho.338784c8.jpg";